module.exports = __webpack_public_path__ + "img/immo_france_logo.c6528bf0.png";